var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HelloWorld"},[_vm._v("HelloWorld")])
}
var staticRenderFns = []

export { render, staticRenderFns }